<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

                <v-card>

                    <v-breadcrumbs divider="/">
                        <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                        <v-breadcrumbs-item to="/users" :exact="true" :disabled="false">Članovi</v-breadcrumbs-item>
                        <v-breadcrumbs-item :disabled="true">Kreiranje</v-breadcrumbs-item>
                    </v-breadcrumbs>

                </v-card>

                <v-card class="fix-card">
                    <form>

                        <v-text-field
                                v-model="user.name"
                                :error="error_messages.name == false"
                                :error-messages="error_messages.name"
                                label="Ime"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="user.lastname"
                                :error="error_messages.lastname == false"
                                :error-messages="error_messages.lastname"
                                label="Prezime"
                        ></v-text-field>

                        <v-text-field
                                v-model="user.email"
                                type="email"
                                :error="error_messages.email == false"
                                :error-messages="error_messages.email"
                                label="Email"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="user.password"
                                type="password"
                                :error="error_messages.password == false"
                                :error-messages="error_messages.password"
                                label="Lozinka"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="user.password_confirmation"
                                type="password"
                                :error="error_messages.password_confirmation == false"
                                :error-messages="error_messages.password_confirmation"
                                label="Potvrda lozinke"
                                required
                        ></v-text-field>

                        <v-select
                                v-if="families"
                                :items="families"
                                label="Porodica"
                                v-model="user.family_id"
                                :error="error_messages.family_id == false"
                                :error-messages="error_messages.family_id"
                                item-text="title"
                                item-value="id"
                        ></v-select>

                        <v-checkbox
                                label="Blokiran"
                                v-model="user.block"
                                color="primary"
                        ></v-checkbox>

                        <v-btn @click="submit()" color="primary">Potvrdi</v-btn>
                        <v-btn @click="clear()" color="secondary" class="black--text">Očisti</v-btn>

                    </form>
                </v-card>

            </v-flex>

        </v-layout>

    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                fillable: ['name', 'lastname', 'email', 'password', 'password_confirmation', 'block', 'family_id',],
                user: {},
                families: false,
                error_messages: [],
            }
        },
        mounted(){
            this.getFamilies();
        },
        computed: {
            userProfile(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
          getFamilies(){
                axios.get('families/lists')
                    .then(res => {
                        this.families = res.data.families;
                    })
                    .catch(e => {
                        console.log(e);
                        this.error = e.response.data.errors;
                    });
            },

            submit(){
                let data = fillForm(this.fillable, this.user);
                axios.post('users', data)
                    .then( res => {
                        swal({
                            position: 'center',
                            type: 'success',
                            title: 'Uspeh',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.push('/users');
                    })
                    .catch( e => {
                        this.error_messages = e.response.data;
                    });
            },
            clear(){
                this.user.name = '';
                this.user.email = '';
                this.user.password = '';
                this.user.password_confirmation = '';
                this.user.block = false;
                this.error_messages = [];
            },
        }
    }
</script>

<style>
    .navbar-laravel {
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
    }

    .fix-card{
        padding: 20px;
        margin-top: 20px;
    }

    .m-20{
        margin-top: 20px;
    }
</style>
